import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import { AuthenticationService } from '../../services/authentication.service';
import { TasksService } from '../../services/tasks.service';

import * as moment from 'moment/moment';

import { Observable } from 'rxjs/Observable';

import { Task } from '../../classes/task';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  public showWelcome: boolean = true;

  public todaysTasks: any;
  public tomorrowsTasks: any;
  public newTask: Task;
  public firstDate = -4;
  public lastDate = 1;
  public weekData: Array<any> = [];
  
  constructor(private AuthenticationService: AuthenticationService, private TasksService: TasksService, private toastr: ToastrService) {
    
  }
  
  ngOnInit() {
    this.getTodaysTasks();
    this.getTomorrowsTasks();
    this.getWeekData();
  }

  getTodaysTasks() {
    var day = new Date();
    this.TasksService.getUserTasksByDay(this.AuthenticationService.id(), day).subscribe(
      data => { 
        this.todaysTasks = data;
      },
      err => console.error(err)
    );
  }

  getTomorrowsTasks() {
    var day = new Date(); day.setDate(day.getDate() + 1);
    this.TasksService.getUserTasksByDay(this.AuthenticationService.id(), day).subscribe(
      data => { 
        this.tomorrowsTasks = data;
      },
      err => console.error(err)
    );
  }

  addTask(taskDetail, taskDay) {
    if(taskDay == 'today'){
      var day = new Date();
    }
    else if(taskDay == 'tomorrow'){
      var day = new Date(); day.setDate(day.getDate() + 1);
    }
    var timezoneOffset = moment(day).format('Z'); timezoneOffset = timezoneOffset.substr(0, 3);
    day.setHours(day.getHours() + parseInt(timezoneOffset));
    var formattedDate = moment(day).format('YYYY-MM-DDTHH:mm:ssZ');
    var prepTask = {
      userId: this.AuthenticationService.id(),
      detail: taskDetail,
      taskDate: formattedDate
    };
    this.TasksService.addTask(prepTask).subscribe(
      data => {
        this.toastr.success('Task Added!');      
        this.getTodaysTasks();
        this.getTomorrowsTasks();
        this.getWeekData();
      },
      err => console.error(err)
    );
  }

  deleteTask(taskId) {
    this.TasksService.deleteTask(taskId).subscribe(
      data => {
        this.toastr.error('Task Deleted.');           
        this.getTodaysTasks();
        this.getTomorrowsTasks();
        this.getWeekData();
      },
      err => console.error(err)
    );
  }

  updateTaskStatus(taskId, status) {
    this.TasksService.updateTaskStatus(taskId, status).subscribe(
      data => {
        if(status == 'incomplete'){
          this.toastr.error('Task Updated'); 
        }
        else if(status == 'complete'){
          this.toastr.success('Task Updated'); 
        }            
        this.getTodaysTasks();
        this.getTomorrowsTasks();
        this.getWeekData();
      },
      err => console.error(err)
    );
  }

  getWeekData() {
    var date1 = new Date(); date1.setDate(date1.getDate() + this.firstDate);
    var date2 = new Date(); date2.setDate(date2.getDate() + this.lastDate);
    this.TasksService.getResultsByDate(this.AuthenticationService.id(), moment(date1).utc().format('YYYY-MM-DD'), moment(date2).utc().format('YYYY-MM-DD')).subscribe(
      (data: Array<any>) => {
        var results = data.reduce(function(map, obj) {
          map[obj._id] = { "complete": obj.completeCount, "count": obj.totalCount};
          return map;
        }, {});
        this.weekData = [];
        for(var day = date1; day <= date2; day.setDate(day.getDate() + 1)) {
          if(day <= new Date()){
            var action = "completed";
          }
          else {
            var action = "created";
          }
          if(results[moment(day).dayOfYear()]) {
            var complete : number= results[moment(day).dayOfYear()].complete;
            var total : number = results[moment(day).dayOfYear()].count;
          }
          else {
            var complete = 0;
            var total = 0;
          }
          this.weekData.push({
            today: moment(day).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD'),
            tomorrow: moment(day).format('YYYY-MM-DD') == moment().add(1, 'days').format('YYYY-MM-DD'),
            weekday: moment(day).format('dddd'),
            date: moment(day).format('DD'),
            complete: complete,
            total: total,
            action: action
          });
        }
      },
      err => console.error(err)
    );
  }

}



// WEBPACK FOOTER //
// /Users/cullenkirkpatrick/Documents/Goals/goal-project/src/app/home/dashboard/dashboard.component.ts